//
import { queryList, saveObject, updateObject, getAllRoleList, getAllRdcList, getAllCarrierList, getResetRoleList, getResetPwd, getDeleteUserList, getForceResetPwd } from './../api';
//import { userType } from '../../../../api'
import { Message } from 'element-ui';
const user = {
  namespaced: true,
  state: {
    successCode: 200,
    resp: null,
    userAdd: null,
    updateData: null,
    allRoleList: null,
    allRdcList: null,
    allCarrierList: null,
    resetRoleList: null,
    resetPwdList: null,
    forceResetPwdList: null,
    deleteUserList: null,
    total: null,
    userTypeObj: null
  },
  mutations: {
    queryList(state, resp) {
      if (resp.code === state.successCode) {
        Message({ showClose: true, message: resp.msg, type: 'success' });
      }
      state.total = resp.total
      state.resp = resp.obj || [];
    },
    SAVE_OBJECT(state, resp) {
      state.userAdd = resp
    },
    UP_DATE_OBJECT(state, resp) {
      state.updateData = resp
    },
    GET_ALL_ROLE_LIST(state, resp) {
      state.allRoleList = resp
    },
    GET_ALL_RDC_LIST(state, resp) {
      state.allRdcList = resp
    },
    GET_ALL_CARRIER_LIST(state, resp) {
      state.allCarrierList = resp
    },
    GET_RESET_ROLE_LIST(state, data) {
      state.resetRoleList = data
    },
    GET_RESET_PWD(state, data) {
      state.resetPwdList = data
    },
    GET_FORCE_RESET_PWD(state, data) {
      state.forceResetPwdList = data
    },
    GET_DELETE_USER(state, data) {
      state.deleteUserList = data
    },
    setData(state, data) {
      state[data.page] = data;
    },
    GET_ALL_USER_TYPE_LIST(state, data) {
      state.userTypeObj = data
    }
  },
  actions: {
    async setData({ commit }, data) {
      commit('setData', data);
    },
    async queryList({ commit }, obj) {
      let resp = await queryList(obj);
      commit('queryList', resp);
    },
    async getAddUser({ commit }, obj) {
      let resp = await saveObject(obj);
      commit('SAVE_OBJECT', resp);
    },
    async updateObject({ commit }, obj) {
      let resp = await updateObject(obj);
      commit('UP_DATE_OBJECT', resp);
    },
    async getAllRoleList({ commit }, obj) {
      let resp = await getAllRoleList(obj);
      commit('GET_ALL_ROLE_LIST', resp);
    },
    async getResetRoleList({ commit }, obj) {
      let resp = await getResetRoleList(obj);
      commit('GET_RESET_ROLE_LIST', resp);
    },
    async getResetPwd({ commit }, obj) {
      let resp = await getResetPwd(obj);
      commit('GET_RESET_PWD', resp);
    },
    async getForceResetPwd({ commit }, obj) {
      let resp = await getForceResetPwd(obj);
      commit('GET_FORCE_RESET_PWD', resp);
    },
    async getDeleteUserList({ commit }, obj) {
      let resp = await getDeleteUserList(obj);
      commit('GET_DELETE_USER', resp);
    },
    //查询rdc
    async getAllRdcList({ commit }, obj) {
      let resp = await getAllRdcList(obj);
      commit('GET_ALL_RDC_LIST', resp);
    },
    //查询carrier
    async getAllCarrierList({ commit }, obj) {
      let resp = await getAllCarrierList(obj);
      commit('GET_ALL_CARRIER_LIST', resp);
    }
    // //查询carrier
    // async listUserType({ commit }, obj) {
    //   let resp = await userType(obj);
    //   commit('GET_ALL_USER_TYPE_LIST', resp);
    //   console.log("---------", user.state.userTypeObj)
    // }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/page/auth/user/store/user.store.js